import OrdersTable from "../../components/ui/OrdersTable";

const OrderScreen = () => {
  return (
    <div
      style={{
        width: "100%",
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        padding: "0 2.6vw 1vw",
      }}
    >
      <OrdersTable />
    </div>
  );
};

export default OrderScreen;
